import { Link } from "react-router-dom";
import { AlertTriangle, CreditCard } from "lucide-react";
import "../../styles/subscription.css";

export default function SubscriptionExpiredPage() {
  return (
    <div className="sub-page sub-result-page">
      <div className="sub-result-card failed">
        <AlertTriangle size={48} />
        <h1>Subscription inactive</h1>
        <p>Your trial or subscription has ended. Renew to restore access to payroll and HR modules.</p>
        <Link to="/settings/subscription" className="sub-btn sub-btn-primary">
          <CreditCard size={15} /> Renew subscription
        </Link>
        <Link to="/pricing" className="sub-btn sub-btn-ghost">Compare plans</Link>
      </div>
    </div>
  );
}
